"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wienervereinWienerstaedtischeTheme = void 0;
exports.wienervereinWienerstaedtischeTheme = {
    logos: {
        memoresaLogoName: "logo_dark.png",
        memoresaLogotypeName: "logotype_dark.png",
        themeLogoName: [
            "wienerverein.svg",
            "s-versicherung-blue.svg",
            "wienerstaedtische.svg",
        ],
    },
    secondary: { main: "#0ca691" },
    navbar: {
        bg: "#ffffff",
        color: "#033354",
        hover: "#275e7b",
    },
};
